import React from "react"
import { Box } from "@mui/system"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as TableBaseIcon } from "src/v2/assets/icons/table-base-icon.svg"
import { Typography } from "@mui/material"
import PropTypes from "prop-types"

const CompanyEmptyState = ({ handleClickFullList }) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "75vh",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    width: "fit-content",
                    textAlign: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                }}
            >
                <Typography variant="body2" color="common.white">
                    Escolha uma Empresa <br /> para visualizar os dados
                </Typography>
                <ButtonWithIcon
                    size={"lg"}
                    icon={<TableBaseIcon />}
                    onClick={handleClickFullList}
                >
                    LISTA COMPLETA
                </ButtonWithIcon>
            </Box>
        </Box>
    )
}

CompanyEmptyState.propTypes = {
    handleClickFullList: PropTypes.func,
}

export default CompanyEmptyState
